import React, { ButtonHTMLAttributes } from 'react';
import classNames from 'classnames';
import { Switch } from '@headlessui/react';

type Props = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'onChange' | 'value'
> & {
  className?: string;
  disabled?: boolean;
  onChange: (enabled: boolean) => void;
  size?: 'medium' | 'large';
  value: boolean;
};

export const Toggle: React.FC<Props> = ({
  className,
  onChange,
  value: active,
  size = 'medium',
  title,
  ...props
}) => {
  const translate =
    size === 'medium'
      ? 'translate-x-4'
      : size === 'large'
      ? 'translate-x-6'
      : '';
  return (
    <button
      type="button"
      {...props}
      className={classNames(
        'flex-none text-left p-0.5 transition-colors duration-300 ease-in-out rounded-full whitespace-nowrap cursor-pointer disabled:bg-grey-200 disabled:cursor-not-allowed focus-within:ring',
        active ? 'bg-mint-green-500' : 'bg-pastel-green-500',
        className,
        {
          'w-8 h-4': size === 'medium',
          'w-12 h-6': size === 'large',
        },
      )}
      aria-checked={active ? true : undefined}
      role="switch"
      onClick={() => onChange(!active)}
    >
      <span
        aria-hidden="true"
        className={classNames(
          'inline-block rounded-full transform transition duration-300 ease-in-out align-top',
          active
            ? `${translate} bg-turf-green-500`
            : 'translate-x-0 bg-slate-green-500',
          {
            'h-3 w-3': size === 'medium',
            'h-5 w-5': size === 'large',
          },
        )}
      />
    </button>
  );
};
